function removeItemsFromArray(array, ...removeArray) {
  return array?.filter((i) => !removeArray?.includes(i));
}
function arrayDifference(deductible, reduced) {
  const result = [];
  const reducedSet = new Set(reduced);
  deductible?.forEach((i) => {
    if (!reducedSet.has(i)) {
      result.push(i);
    }
  });
  return result;
}
function getObjectListWithUniqueKey(array, key) {
  const uniqueKeyValues = [...new Set(array?.map((i) => i[key])?.filter((i) => i))];
  return uniqueKeyValues?.map((value) => array?.find((i) => i[key] === value));
}
export {
  arrayDifference,
  getObjectListWithUniqueKey,
  removeItemsFromArray
};
//# sourceMappingURL=array.js.map
